import type { ReactNode } from 'react';

export const symbol_tour: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M260-410v300q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63Q200-97.25 200-110v-740q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v54h535q15.87 0 24.93 13.5Q829-769 823-754l-64 151 64 151q6 15-3.07 28.5Q810.87-410 795-410H260Zm0-326v266-266Zm292 183.79q21-21.21 21-51T551.79-654q-21.21-21-51-21T450-653.79q-21 21.21-21 51T450.21-552q21.21 21 51 21T552-552.21ZM260-470h491l-55-133 55-133H260v266Z"
		/>
	</svg>
);
